import React, { useMemo } from "react";
import { isStartListStatus, isLiveStatus, isFinishedStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Status from "components/presentation/Status";
import { TableColumns as ColumnsStarList, TableColumnsSM as ColumnsStarListSM } from 'components/sports/ows/events/ows_race/start/Columns'
import {
    TableColumnsLive as ColumnsLive,
    TableColumnsLiveSM as ColumnsLiveSM,
    TableColumnsFinish as ColumnsOfficial,
    TableColumnsFinishSM as ColumnsOfficialSM
} from 'components/sports/ows/events/ows_race/results/Columns'
import { TableExpanded as TEOws } from 'components/sports/ows/events/ows_race/results/TableExpanded'

import { hasConfig } from "components/sports/ows/helper/OwsHelpers"

//import TableMin from "components/table/TableMin";
import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils'

//Race Info
import OwsRaceInfo from 'components/sports/ows/views/OwsRaceInfo'

const getConfiguration = (data, rsc, resultStatus, breakPoint, caption) => {

    const columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []

    const maxLap = findArray(data?.results?.extendedInfos, { ei_code: ['CURRENT_INTERMEDIATE'] })?.ei_value

    const isStartList = isStartListStatus(resultStatus) ? true : false
    const isLive = isLiveStatus(resultStatus) ? true : false
    const isFinish = isFinishedStatus(resultStatus) ? true : false

    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: [],
        configs: {
            isStartList: isStartList,
            columnsAdded: columnsAdded,
        }
    };



    configuration.caption = isStartList
        ? <CaptionTable leftCol={<>{caption}</>} />
        : <CaptionTable leftCol={<>{caption}</>} rightCol={<Status typeToPrint='result' scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={resultStatus} />} />

    configuration.sortBy = isStartList
        ? [{ id: 'Bib', desc: false }]
        : isLive
            //is live
            ? (isLive)
                ? [{ id: 'RankIntermediate', desc: false }]
                : [{ id: 'Rank', desc: false }]
            //Finish
            : (isFinish)
                ? [{ id: 'Rank', desc: false }]
                : [{ id: 'Rank', desc: false }]


    configuration.filters = {
        ei_type: ['DISPLAY'],
        ei_code: ['INTERMEDIATE_CURRENT']
    };

    configuration.columns = isStartList
        ? breakPoint === "sm" || breakPoint === "xs"
            ? ColumnsStarListSM()
            : ColumnsStarList()
        : isLive
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsLiveSM(columnsAdded, maxLap)
                : ColumnsLive(columnsAdded, maxLap)
            : breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsOfficialSM(columnsAdded)
                : ColumnsOfficial(columnsAdded);

    return configuration;
};


const OwsResults = ({ data, caption }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;

    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus, breakPoint, caption), [resultStatus, mirs_rsc, breakPoint]);

    const renderRowSubComponent = React.useCallback(({ row }) => {

        let componentExpanded = '';
        componentExpanded = <TEOws row={row?.original} config={configEvent.configs.columnsAdded} />

        return (

            <LoaderSubComponent component={componentExpanded} />

        )
        // eslint-disable-next-line
    }, [resultStatus]);


    const items = data?.results?.items
    const showAllExtendedResults = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    //const showAllresultAnalysis = items?.some(item => item?.resultAnalysis?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    //const showAllTeamAthletes = items?.teamathletes?.some(val => val.hasOwnProperty('athlete'));
    //const showAll = showAllExtendedResults || showAllTeamAthletes;
    const showAll = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    const hasConfiguration = hasConfig(configEvent.configs.columnsAdded)


    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []
    if (!showAll && !hasConfiguration) hiddenColumns.push('Expander')

    return (
        <>

            {data?.results ? (
                <>

                    {data?.results?.items ? (
                        < MirsTable
                            className='table-result'
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //subcomponente a renderizar, extended
                            renderRowSubComponent={renderRowSubComponent}
                            //pageSizeCustom={data.items.length} //ponerlo por defecto en el componente                             
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde 
                            hiddenColumns={hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            //Show buttons move to splits 
                            showNavExtendedData={true}
                            id={`mirs-table-result-${mirs_rsc}`}
                            hasRelatedTimeline={true}
                        />
                    ) : ('')
                    }

                </>
            ) : (
                <span><em>No data available</em></span>
            )
            }
            {data?.config ? (
                <OwsRaceInfo config={data.config} />
            ) : ""}
        </>
    );
};

export default OwsResults;
